import type { SwitchProfileTypeType } from '@shared/constants/constants';
import { SwitchProfileType } from '@shared/constants/constants';
import type { GetRelatedPeopleResult } from '@shared/services/caregivers/types/getRelatedPeople.types';

export const checkEmptyRelatedPeople = (
  data: GetRelatedPeopleResult | undefined,
  switchProfileType: SwitchProfileTypeType,
  bypassEmptyCheckAndShowSelf?: boolean
) => {
  if (bypassEmptyCheckAndShowSelf) return false;

  if (switchProfileType === SwitchProfileType.CHILDREN && !data?.Children?.length) return true;

  if (switchProfileType === SwitchProfileType.FAMILY && !data?.FamilyAndFriend?.length) return true;

  return !data?.FamilyAndFriend?.length && !data?.Children?.length;
};
